import {
  Flex,
  FlexProps,
  Grid,
  GridItem,
  GridItemProps,
  GridProps,
  Table,
  TableProps,
} from "@chakra-ui/react";

import ErrorBoundary from "@/common/components/ErrorBoundary";
import { useSidebar } from "@/common/hooks/useSidebar";

type SidebarLayoutProps = GridProps & {
  sidebarContent?: React.ReactNode;
  sidebarKey?: string;
  sidebarProps?: GridItemProps;
};

export default function SidebarLayout({
  children,
  sidebarContent,
  sidebarKey,
  sidebarProps,
  ...props
}: SidebarLayoutProps) {
  const { isVisible } = useSidebar(sidebarKey);
  const showSidebar = isVisible && sidebarContent;

  if (!showSidebar) {
    return children;
  }

  return (
    <Grid
      h="100%"
      templateColumns="repeat(3, 1fr) clamp(230px, 20%, 270px)"
      w="100%"
      {...props}
    >
      <GridItem
        borderRight="1px solid"
        borderRightColor="appBorder"
        colSpan={3}
        display="flex"
        flexDirection="column"
        flexGrow={1}
      >
        <ErrorBoundary>{children}</ErrorBoundary>
      </GridItem>
      <GridItem as="aside" colSpan={1} {...sidebarProps}>
        <ErrorBoundary>{sidebarContent}</ErrorBoundary>
      </GridItem>
    </Grid>
  );
}

export function SidebarContainer({ children, ...rest }: FlexProps) {
  return (
    <Flex direction="column" gap={5} p={6} {...rest}>
      {children}
    </Flex>
  );
}

export function SidebarSection({ children, ...rest }: FlexProps) {
  return (
    <Flex direction="column" gap={2} {...rest}>
      {children}
    </Flex>
  );
}

export function SidebarTable({ children, ...props }: TableProps) {
  return (
    <Table
      {...props}
      fontSize="sm"
      size="xs"
      sx={{
        td: {
          py: 1,
        },
      }}
      variant="unstyled"
    >
      {children}
    </Table>
  );
}
